import { render, staticRenderFns } from "./FeedbackButton.vue?vue&type=template&id=761f4f47&"
import script from "./FeedbackButton.vue?vue&type=script&lang=js&"
export * from "./FeedbackButton.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackButton.vue?vue&type=style&index=0&id=761f4f47&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports